import * as React from "react";

import { useHackyParams } from "~/lib/constants";
import { useAccountStore } from "~/stores/space";

export function useCurrentSpace() {
  const { store: account } = useAccountStore();

  const params = useHackyParams<{ account: string; space: string }>();

  if (account.slug !== params.account) {
    throw new Error(
      `Account ${params.account} does not match current loaded account`,
    );
  }
  const space = React.useMemo(
    () => account.spaceBySlug(params.space!),
    [params.space, account],
  );
  if (!space) {
    throw new Error(`Workspace ${params.space} not found`);
  }

  return { account, space };
}
